import { Pipe, PipeTransform } from '@angular/core';
import { Nullable } from 'primeng/ts-helpers';
import { LanguageService } from '../../core/services/language.service';
import { Languages } from '../enums/languages.enum';

@Pipe({
  name: 'translateI18nObject',
  standalone: true
})
export class TranslateI18nObjectPipe implements PipeTransform {

  constructor(private languageService: LanguageService) { }

  public transform(
    value: { [key in string]?: string } | string | Nullable,
    language?: Languages | Nullable,
    fallback?: string
  ): string {
    return this.languageService.resolveI18NObject(value, language, fallback);
  }

}
